import mixin from "@/mixin/index.js";
import BigNumber from "bignumber.js";
const _formatNumber = mixin.methods._formatNumber;
const _roundNumber = mixin.methods._roundNumber;
import calculatorLabels from "@/constants/labels/calculators.labels.js";

const volumeToDrops = {
    name: 'Gotejamento | mL/hora para Gotas',
    id: 'cd095fdd045240a6a5ffce15264d6c9f',
    classes: ['Fluidoterapia'],
    premium: true,
    variables: [
        {
            name: 'Velocidade em mL/Hora',
            type: 'number',
            placeholder: 'Insira a velocidade em mL/Hora',
            id: 'speed',
            default: 0,
            suffix: 'mL/hora'
        },
    ],
    calculate: ({ speed }) => {
        if (!speed) {
            return;
        }
        speed = new BigNumber(speed.replace(',', '.'));
        let response = { type: 'multiple', values: [] };
        response.values.push({ description: 'Velocidade na bomba de infusão', value: _formatNumber(_roundNumber(speed, 2), ' mL/hora'), hideResultClass: true });
        response.values.push({
            description: 'Velocidade no equipo Macrogotas', values: [
                _formatNumber(_roundNumber(speed.dividedBy(180), 2), ' gotas/segundo'),
                _formatNumber(_roundNumber(speed.dividedBy(18), 2), ' gotas/10 segundos'),
                _formatNumber(_roundNumber(speed.dividedBy(3), 2), ' gotas/minuto'),
                _formatNumber(_roundNumber(new BigNumber(180).dividedBy(speed), 2), ' segundos/gota'),
            ], hideResultClass: true
        });
        response.values.push({
            description: 'Velocidade no equipo Microgotas', values: [
                _formatNumber(_roundNumber(speed.dividedBy(60), 2), ' gotas/segundo'),
                _formatNumber(_roundNumber(speed.dividedBy(6), 2), ' gotas/10 segundos'),
                _formatNumber(_roundNumber(speed, 2), ' gotas/minuto'),
                _formatNumber(_roundNumber(new BigNumber(60).dividedBy(speed), 2), ' segundos/gota'),
            ], hideResultClass: true
        });
        return response;
    },
    responseLabel: "Velocidade de Administração",
    sections: [],
    references: []
}
const dropsToVolume = {
    name: 'Gotejamento | Gotas para mL/hora',
    id: calculatorLabels.DROPS_TO_VOLUME,
    classes: ['Fluidoterapia'],
    premium: true,
    routeName: calculatorLabels.DROPS_TO_VOLUME,
    sections: [],
    references: []
}
export default { volumeToDrops, dropsToVolume }